import { useEffect } from 'react';
import PropTypes from 'prop-types';
// material
import {
  Typography,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Alert
} from '@material-ui/core';
// icons
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useIsFeatureFlagEnabled } from '../../../utils/FeatureFlags';
import { GatewaySize, EnableFlightSimulator } from '.';
import InitScripts from './InitScripts';

const styles = {
  advancedSettings: {
    paddingLeft: 0
  }
};

GatewayInfo.propTypes = {
  updateRack: PropTypes.func,
  rack: PropTypes.object,
  setNextButtonDisabled: PropTypes.func
};

export default function GatewayInfo({ rack, updateRack, setNextButtonDisabled }) {
  const isFlightSimulatorEnabled = useIsFeatureFlagEnabled('flight_simulator');
  const isSnapshotSelected = !!rack.rack?.snapshotDetails?.name;

  const updateRackGateway = (key, value) => {
    // updates the rack object's gateway property with the new values
    const rackCopy = { ...rack };
    rackCopy.rack.gateway[key] = value;
    updateRack(rackCopy);
  };

  useEffect(() => {
    validateInputs();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  const validateInputs = () => {
    setNextButtonDisabled(false);
  };

  return (
    <>
      {isSnapshotSelected && (
        <Grid item xs={12}>
          <Alert severity="warning">
            Gateway settings cannot be modified when a snapshot is selected.
          </Alert>
        </Grid>
      )}
      <Grid data-testid="gateway-settings" container item spacing={2} ml={2} mt={1} mb={2} xs={12}>
        <Grid container item sm={12} spacing={2}>
          <GatewaySize updateRack={updateRack} rack={rack} />
        </Grid>
        {isFlightSimulatorEnabled ? (
          <Grid container item sm={12} spacing={2}>
            <EnableFlightSimulator updateRack={updateRack} rack={rack} />
          </Grid>
        ) : null}
        <Grid item sm={12}>
          <Accordion>
            <AccordionSummary sx={styles.advancedSettings} expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">Advanced Settings</Typography>
            </AccordionSummary>
            <AccordionDetails sx={styles.advancedSettings}>
              <InitScripts
                isSnapshotSelected={isSnapshotSelected}
                setNextButtonDisabled={setNextButtonDisabled}
                rackInitScript={rack.rack.gateway.initScript}
                rackBootScript={rack.rack.gateway.bootScript}
                updateRackInitScript={(script) => updateRackGateway('initScript', script)}
                updateRackBootScript={(script) => updateRackGateway('bootScript', script)}
              />
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </>
  );
}
